import { Button, Icon, Typography } from '@equinor/eds-core-react'

import styled from 'styled-components'

import SupportEmail from '@/components/supportEmail'

const GenericError = () => {
    return (
        <Container>
            <Img src="/errorImage.svg" alt="ErrorImage" />
            <TextContainer>Oops, Something went wrong here…</TextContainer>
            <Typography variant="body_short">
                If the problem persists, contact <SupportEmail /> for assistance.
            </Typography>
            <Button variant="ghost" color="secondary" onClick={() => window.location.reload()}>
                <Icon name="refresh" />
                Reload to try again
                <div />
            </Button>
        </Container>
    )
}

const Container = styled.div`
    align-items: center;
    display: flex;
    flex: 1 1 100%;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 2rem;
    overflow: hidden;

    & > p {
        margin: 0.5rem 0 2rem;
    }
`

const TextContainer = styled.span`
    font-size: 2rem;
    font-weight: bold;
`

const Img = styled.img`
    width: 25%;
`

export default GenericError
